<form #formBagPickupLocationEdit="ngForm" class="location-residential" id="confirmAddress"
  name="formBagPickupLocationEdit" (submit)="handleSubmitLocation(formBagPickupLocationEdit, $event)" novalidate>

  <div class="form-group form-group-lg margin-bottom-32" [ngClass]="{ 'hidden' : !showManualInput }">
    <input class="form-control box-shadow"
      [ngClass]="{ 'has-error' : collectionAddressLine1.invalid && collectionAddressLine1.dirty || errorNoPostcode }"
      id="collectionAddressLine1" name="collectionAddressLine1" ngControl="collectionAddressLine1"
      #collectionAddressLine1="ngModel" [(ngModel)]="locationData.addressLine1" type="text" required appCheckEmpty>
    <label class="control-label"
      for="collectionAddressLine1">{{appCopy.panelHeader['addLineLabel'+selectedLanguage]}}</label>
    <a class="control-btn" (click)="clearInput()" href="javascript:void(0)">
      <i class="icon">cross</i>
    </a>
    <p class="help-block text-danger"
      *ngIf="collectionAddressLine1.invalid && collectionAddressLine1.dirty || errorNoPostcode">
      {{appCopy.panelHeader['errorTextAddLine'+selectedLanguage]}}
    </p>
  </div>

  <div class="form-group form-group-lg margin-bottom-32" [ngClass]="{ 'hidden' : showManualInput }">
    <app-location-residential-lookup [placeholder]="addressLookupPlaceholder" [recentAddressLabel]="recentAddressLabel"
      [manuallyAddressLabel]="manuallyAddressLabel" [moreAddressLabel]="moreAddressLabel"
      [errorTextOutOfCoverageArea]="errorTextOutOfCoverageArea"
      [errorTextPostCodeIsMissing]="errorTextPostCodeIsMissing" [errorTextAddLine]="errorTextAddLine"
      [userAddresses]="userAddresses" [selectedAddressLine]="selectedAddressLine" [errorNoPostcode]="errorNoPostcode"
      [errorPostcodeNotEntered]="errorPostcodeNotEntered" (changedAddressLine)="changedAddressLine($event)"
      (selectedLocationResidential)="getChildLocation($event)"
      (selectedSavedLocationResidential)="selectedSavedLocationResidential($event)"
      (showManualInput)="showManualInput = true" (toggleShowMenu)="toggleShowMenu($event)">
    </app-location-residential-lookup>
  </div>

  <a class="link margin-bottom-16" style="color: #0037EB;" href="javascript:void(0)" (click)="showManualInput = true"
    *ngIf="!showManualInput">{{appCopy.panelHeader['manualAddressLabel'+selectedLanguage]}}</a>

  <div *ngIf="showManualInput">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <input class="form-control" id="collectionAddressLine2" name="collectionAddressLine2"
            ngControl="collectionAddressLine2" #collectionAddressLine2="ngModel" [(ngModel)]="locationData.addressLine2"
            type="text" autocomplete="off" appCheckEmpty>
          <label class="control-label"
            for="collectionAddressLine2">{{appCopy.panelHeader['addLineTwoLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input #postcodeElement class="form-control"
            [ngClass]="{ 'has-error' : collectionAddressPostcode.invalid && collectionAddressPostcode.dirty || postcodeInvalid || !postcodeInZone }"
            id="collectionAddressPostcode" name="collectionAddressPostcode" ngControl="collectionAddressPostcode"
            #collectionAddressPostcode="ngModel" [(ngModel)]="locationData.addressPostCode"
            (ngModelChange)="postcodeChange($event)" type="text" minlength="4" maxlength="8" autocomplete="off" required
            appCheckEmpty>
          <label class="control-label"
            for="collectionAddressPostcode">{{appCopy.panelHeader['postcodeLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state" *ngIf="!postcodeCheck"></i>
          <div class="loader-container-typeahead" *ngIf="postcodeCheck">
            <div class="loader loader--gray">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
          <p class="help-block text-danger"
            *ngIf="collectionAddressPostcode.invalid && collectionAddressPostcode.dirty || postcodeInvalid">
            {{appCopy.panelHeader['errorTextPostcodeRequired'+selectedLanguage]}}
          </p>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <input class="form-control"
            [ngClass]="{ 'has-error' : collectionAddressTown.invalid && collectionAddressTown.dirty || cityInvalid }"
            id="collectionAddressTown" name="collectionAddressTown" ngControl="collectionAddressTown"
            #collectionAddressTown="ngModel" [(ngModel)]="locationData.addressTown" type="text" autocomplete="off"
            required appCheckEmpty>
          <label class="control-label"
            for="collectionAddressTown">{{appCopy.panelHeader['townCityLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>
          <p class="help-block text-danger"
            *ngIf="collectionAddressTown.invalid && collectionAddressTown.dirty || cityInvalid">
            {{appCopy.panelHeader['errorTextTownCity'+selectedLanguage]}}
          </p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <input class="form-control" id="collectionAddressName" name="collectionAddressName"
            ngControl="collectionAddressName" #collectionAddressName="ngModel" [(ngModel)]="locationData.name"
            type="text" autocomplete="off" appCheckEmpty>
          <label class="control-label"
            for="collectionAddressName">{{appCopy.panelHeader['businessLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>
          <p class="help-block text-danger" *ngIf="collectionAddressName.invalid && collectionAddressName.dirty">
            {{appCopy.panelHeader['errorTextBusiness'+selectedLanguage]}}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group form-group-lg with-select">
          <select class="form-control box-shadow" name="collectionAddressCountry" id="collectionAddressCountry"
            ngControl="collectionAddressCountry" #collectionAddressCountry="ngModel"
            [ngClass]="{ 'has-error' : collectionAddressCountry.invalid && collectionAddressCountry.dirty }"
            [(ngModel)]="locationData.addressCountry" (ngModelChange)="countryChange($event)" autocomplete="off"
            required appCheckEmpty>
            <option value="" disabled></option>

            <option *ngFor="let item of countriesList" [value]="item">{{item}}</option>

          </select>
          <label class="control-label"
          for="collectionAddressCountry">{{appCopy.panelHeader['countryLabel'+selectedLanguage]}}</label>
          <p class="help-block text-danger" *ngIf="collectionAddressCountry.invalid && collectionAddressCountry.dirty">
            {{appCopy.panelHeader['errorTextCountry'+selectedLanguage]}}
          </p>
        </div>
      </div>
      <!-- <div class="col-md-6">
        <div class="custom-typeahead" (clickOutside)="close()" appClickOutside>
          <div class="form-group">
            <input class="form-control" id="collectionAddressCountry" name="collectionAddressCountry"
              ngControl="collectionAddressCountry" #collectionAddressCountry="ngModel"
              [ngClass]="{ 'has-error' : collectionAddressCountry.invalid && collectionAddressCountry.dirty }"
              [(ngModel)]="locationData.addressCountry" (ngModelChange)="countryChange($event)" type="text"
              autocomplete="off" required appCheckEmpty>
            <label class="control-label" for="collectionAddressCountry">Country</label>
            <a *ngIf="locationData.addressCountry.length > 1" class="control-btn" (click)="clearCountryInput()" href="javascript:void(0)">
              <i class="icon">cross</i>
            </a>
            <i class="icon control-validation-state"></i>
            <p class="help-block text-danger" *ngIf="collectionAddressCountry.invalid && collectionAddressCountry.dirty">
              Please
              enter your country name</p>
          </div>
          <div *ngIf="countryList.length > 0 && !countrySelected" class="items fadeIn">
            <div class="items-wrapper">
              <div class="item" *ngFor="let item of countryList; let i = index"
                (click)="handleCountrySelection(item)" [ngClass]="{active:isCurrent(i)}" (mouseenter)="setCurrent(i)">
                <a href="javascript:void(0)" class="title">{{ item }}</a>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>

  <ng-template [ngIf]="((bookingProduct === 'ccd' && arrivalAirportCode === 'ZRH') || (bookingProduct === 'abc' && departureAirportCode === 'ZRH')) && hoursDifference > 48" [ngIfElse]="notZhr">
    <div class="alert alert-danger" *ngIf="bookingType !== 'amend' && (formHasErrors || (!postcodeInvalid && !postcodeInZone))">
      <p [innerHTML]="appCopy.panelHeader['ZrhPostCodeOutOfService'+selectedLanguage]"></p>
    </div>
  </ng-template>

  <ng-template #notZhr>
    <div class="alert alert-danger" *ngIf="formHasErrors">
      <p>{{appCopy.panelHeader['errorText'+selectedLanguage]}}</p>
    </div>
  </ng-template>
  <p class="alert alert-danger" *ngIf="!isGeoCoordAvailable">{{appCopy.panelHeader['geoCoordErrorMessage'+selectedLanguage]}}</p>

  <app-subsidy *ngIf="isSbbSubsidyApplicable || isSbbSubsidyApplied"
    [appAirportCopy]="appAirportCopy" [appCopy]="appCopy"
    [selectedLanguage]="selectedLanguage" [isSbbSubsidyApplied]="isSbbSubsidyApplied">
  </app-subsidy>

  <p class="alert alert-danger" *ngIf="!postcodeInZone" [innerHTML]="appCopy.panelHeader['errorTextPostcodeOutOfCoverageArea'+selectedLanguage]"><p>

  <button id="formBagPickupLocationEdit-submit" *ngIf="showManualInput" type="submit" class="btn btn-purple btn-block margin-bottom-32"
    [disabled]="isLoading || geoLoading || !isGeoCoordAvailable || !postcodeInZone || virtualBagsCount === 0 || virtualBagsCount > 25">

    <div class="loader-container-btn" *ngIf="isLoading">
      <div class="loader loader--white">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
    {{appCopy.panelHeader['buttonContinue'+selectedLanguage]}}
  </button>

</form>
